export var InputMethod;
(function (InputMethod) {
    InputMethod[InputMethod["NotDefined"] = -1] = "NotDefined"; /* Used only for converting TryToSetIpSelection to use default parameters instead of [AlternateSignature] */
    InputMethod[InputMethod["Unknown"] = 0] = "Unknown";
    InputMethod[InputMethod["Keyboard"] = 1] = "Keyboard";
    InputMethod[InputMethod["Mouse"] = 2] = "Mouse";
    InputMethod[InputMethod["Touch"] = 3] = "Touch";
    InputMethod[InputMethod["Pen"] = 4] = "Pen";
    InputMethod[InputMethod["CrossSlide"] = 9] = "CrossSlide";
})(InputMethod || (InputMethod = {}));
export function getInputMethodFromEvent(ev) {
    var inputMethod = undefined;
    if (ev) {
        var type = ev.type.toLowerCase();
        if (type === 'click') {
            inputMethod = ev.nativeEvent.detail === 0 ? InputMethod.Keyboard : InputMethod.Mouse;
        }
        else if (type === 'keydown' || type === 'keypress' || type === 'keyup') {
            inputMethod = InputMethod.Keyboard;
        }
        else if (type === 'mousedown') {
            inputMethod = InputMethod.Mouse;
        }
    }
    return inputMethod;
}
//# sourceMappingURL=InputMethod.js.map